import { onMounted, onUnmounted, watch } from 'vue'

export function useKeyboard({ onCapture, onNext, onPrev, onFilterNext, onFilterPrev, canvasWrapper }) {
  let startX = 0
  let startY = 0
  let dragging = false

  function handleKeydown(e) {
    if (e.code === 'Space') {
      e.preventDefault()
      onCapture()
    } else if (e.code === 'ArrowRight') {
      e.preventDefault()
      onNext()
    } else if (e.code === 'ArrowLeft') {
      e.preventDefault()
      onPrev()
    } else if (e.code === 'ArrowUp') {
      e.preventDefault()
      onFilterPrev()
    } else if (e.code === 'ArrowDown') {
      e.preventDefault()
      onFilterNext()
    }
  }

  function handleSwipe(dx, dy) {
    const absDx = Math.abs(dx)
    const absDy = Math.abs(dy)
    if (absDx < 50 && absDy < 50) return
    if (absDx > absDy) {
      if (dx > 0) onPrev()
      else onNext()
    } else {
      if (dy > 0) onFilterPrev()
      else onFilterNext()
    }
  }

  function handleTouchStart(e) {
    startX = e.touches[0].clientX
    startY = e.touches[0].clientY
  }

  function handleTouchEnd(e) {
    handleSwipe(e.changedTouches[0].clientX - startX, e.changedTouches[0].clientY - startY)
  }

  function handleMouseDown(e) {
    dragging = true
    startX = e.clientX
    startY = e.clientY
  }

  function handleMouseUp(e) {
    if (!dragging) return
    dragging = false
    handleSwipe(e.clientX - startX, e.clientY - startY)
  }

  function bindSwipeEvents(el) {
    if (!el) return
    el.addEventListener('touchstart', handleTouchStart, { passive: true })
    el.addEventListener('touchend', handleTouchEnd, { passive: true })
    el.addEventListener('mousedown', handleMouseDown)
    el.addEventListener('mouseup', handleMouseUp)
  }

  function unbindSwipeEvents(el) {
    if (!el) return
    el.removeEventListener('touchstart', handleTouchStart)
    el.removeEventListener('touchend', handleTouchEnd)
    el.removeEventListener('mousedown', handleMouseDown)
    el.removeEventListener('mouseup', handleMouseUp)
  }

  let boundEl = null

  onMounted(() => {
    window.addEventListener('keydown', handleKeydown)
    if (canvasWrapper && canvasWrapper.value) {
      boundEl = canvasWrapper.value
      bindSwipeEvents(boundEl)
    }
  })

  // Watch for ref becoming available
  if (canvasWrapper) {
    watch(canvasWrapper, (newEl, oldEl) => {
      if (oldEl) unbindSwipeEvents(oldEl)
      if (newEl) {
        boundEl = newEl
        bindSwipeEvents(newEl)
      }
    })
  }

  onUnmounted(() => {
    window.removeEventListener('keydown', handleKeydown)
    if (boundEl) unbindSwipeEvents(boundEl)
  })
}
